import { Button, Form } from "react-bootstrap";
import { Modal } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import useActas from "../../../api/actas";
import { useState } from "react";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { format } from 'date-fns';


const ModalDescargo = ({ modals, handlerModal, setRefetch }) => {
    const fechaHoy = format(new Date(), 'yyyy-MM-dd');

    //? ESTADOS GLOBALES
    const { loads } = useGeneralAppStore();
    const { actaDetalle } = useActaDetalleStore();

    //TODO API
    const { cambiarEstadoDescargo } = useActas();
    const [observacion, setObservacion] = useState("");
    const [fecha, setFecha] = useState(fechaHoy);



    // console.log(fecha)
    return (
        <>
            <Modal
                show={modals.includes('descargo')}
                size={"md"}
                onHide={() => handlerModal({ modal: false, modalName: "descargo" })}
                title={() => "Cambiar estado a DESCARGO"}
            >

                <div className="d-flex flex-column gap-3">
                    <Form.Group>
                        <Form.Label>Fecha: </Form.Label>
                        <Form.Control
                            defaultValue={fecha}
                            type="date"
                            onChange={(e) => { setFecha(e.target.value) }}
                            style={{ resize: "none" }}
                            rows={4}
                        />
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Observación: </Form.Label>
                        <Form.Control
                            onChange={(e) => { setObservacion(e.target.value) }}
                            style={{ resize: "none" }}
                            as={'textarea'}
                            rows={4}
                        />
                    </Form.Group>


                    <div style={{ minHeight: "50px" }} className="d-flex flex-column">
                        {(observacion == "") && <span className="text-danger">Dege agregar una observación</span>}
                        {(fecha == "") && <span className="text-danger">Dege agregar una fecha</span>}
                    </div>
                    <hr />
                    <Button
                        variant="dark"
                        size="sm"
                        style={{ width: "fit-content" }}
                        onClick={() =>
                            // console.log({ id: actaDetalle.acta.id, observacion_descargo: observacion, fecha_descargo: fecha })
                            cambiarEstadoDescargo({ id: actaDetalle.acta.id, observacion_descargo: observacion, fecha_descargo: fecha }, setRefetch)
                        }
                        disabled={loads.includes('descargo') || (observacion == "") || (fecha == "") }
                    >
                        {loads.includes('descargo')
                            ? "Guardando cambios..."
                            : "Marcar a DESCARGO"}
                    </Button>
                </div>

            </Modal>
        </>
    );
}
export default ModalDescargo;